import {
  TextArea as BaseTextArea,
  type TextAreaProps as BaseTextAreaProps,
} from '@y2/mango/components/text-area';
import {
  useController,
  type Control,
  type FieldValues,
  type Path,
} from 'react-hook-form';

export type TextAreaProps<T extends FieldValues> = Omit<
  BaseTextAreaProps,
  'value'
> & {
  name: Path<T>;
  label?: string;
  error?: string;
  control: Control<T>;
};

export const TextArea = <T extends FieldValues>({
  name,
  label,
  error,
  control,
  ...props
}: TextAreaProps<T>) => {
  const { field } = useController({ name, control });

  return (
    <BaseTextArea
      name={name}
      label={label}
      value={field.value}
      onChange={field.onChange}
      hasError={!!error}
      helperText={error}
      ref={field.ref}
      {...props}
    />
  );
};
